import React from 'react';
import { UtensilsIcon, PizzaIcon, BeefIcon, DrumstickIcon, CupSodaIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const menuHighlights = [{
  icon: BeefIcon,
  name: 'Signature Burgers',
  description: 'Juicy, flame-grilled burgers with all the fixings'
}, {
  icon: PizzaIcon,
  name: 'Fresh Pizza',
  description: 'Hand-tossed pizzas with premium toppings'
}, {
  icon: DrumstickIcon,
  name: 'Crispy Wings',
  description: 'Perfectly seasoned wings with your choice of sauce'
}, {
  icon: CupSodaIcon,
  name: 'Refreshing Drinks',
  description: 'Sodas, shakes, and specialty beverages'
}];
export function DiningSection() {
  return <section id="dining" className="py-16 md:py-24 px-4 bg-gradient-to-br from-pulse-orange/10 via-pulse-yellow/5 to-white" data-id="element-93">
      <div className="max-w-7xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-95">
          <div className="inline-flex items-center gap-2 bg-pulse-orange/10 text-pulse-orange px-4 py-2 rounded-full mb-6" data-id="element-96">
            <UtensilsIcon className="h-5 w-5" data-id="element-97" />
            <span className="font-semibold text-sm uppercase tracking-wide" data-id="element-98">
              Coming Soon
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-pulse-navy uppercase tracking-tight" data-id="element-99">
            Fuel Your Fun — Coming Soon
          </h2>

          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-100">
            Our full-service restaurant will serve up delicious food for the
            whole family. Here's a taste of what's on the menu.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-101">
          {menuHighlights.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={item.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className="bg-white rounded-2xl shadow-lg p-6 text-center border-b-4 border-pulse-orange" data-id="element-102">
                <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-br from-pulse-orange to-pulse-yellow flex items-center justify-center mb-4" data-id="element-103">
                  <Icon className="h-8 w-8 text-white" data-id="element-104" />
                </div>
                <h3 className="text-xl font-bold text-pulse-navy mb-2" data-id="element-105">
                  {item.name}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-106">{item.description}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12" data-id="element-107">
          <p className="text-gray-600 mb-4" data-id="element-108">
            Full menu details coming soon. Sign up to be the first to see it!
          </p>
          <a href="#signup" className="inline-flex items-center gap-2 border-2 border-pulse-orange text-pulse-orange hover:bg-pulse-orange hover:text-white px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all" data-id="element-109">
            Get Menu Updates
          </a>
        </motion.div>
      </div>
    </section>;
}